module.exports = __webpack_public_path__ + "img/shop_basketBall_women.1b84abd9.jpg";